module.exports = __webpack_public_path__ + "img/Type_Ghost.a4eb90c9.png";